import React, { useEffect } from 'react';
import { Button, Icon, Tooltip } from 'antd';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import isEmpty from 'app/utils/IsEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationsDispatch, fetchWorkCycleFiltersFields } from 'app/actions/WorkCycleActions';
import { fetchCommunicationDispatchFilter } from 'app/actions/CommunicationProgramActions';
import { getWorkCycleEvaluation, getCommunicationDispatchFilter, getIsLoadingWorkCycleEvaluation } from 'app/reducers';

export default function WorkCycleEvaluationTableContainer(props) {
    const { classes } = props;

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    let communications = useSelector(getWorkCycleEvaluation);
    let communicationDispatchFilter = useSelector(getCommunicationDispatchFilter);

    const columns = [
        {
            title: 'Colaborador',
            dataIndex: 'employeeName',
            key: 'employeeName',
            sorter: true,
            ellipsis: true,
            width: 270,
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: true,
            ellipsis: true,
            width: 270,
        },
        {
            title: 'Programa de comunicación',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            ellipsis: true,
            width: 370,
        },
         {
            title: 'Pernocta',
            dataIndex: 'pernocta',
            key: 'pernocta',
            sorter: true,
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Procedimiento',
            dataIndex: 'courseName',
            key: 'courseName',
            sorter: true,
            ellipsis: true,
            width: 270,
        },
        {
            title: 'Vigencia',
            dataIndex: 'diffusionEndDate',
            key: 'diffusionEndDate',
            sorter: true,
            width: 170,
            render: (date) => {
                return moment(date).locale('es').format('L')
            }
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName  ',
            sorter: true,
            // width: 'auto',
            width: 170,
        },
        {
            
        },
        {
            title: 'Acciones',
            fixed: 'right',
            width: 80,
            key: 'idCommunication',
            dataIndex: 'idCommunication',
            render: (id, row) => (
                props.selectedRows.length > 1 ?
                    <Tooltip placement="bottom" title={'Evaluar CT'}>
                        <Button type="primary" shape="circle" icon="form" disabled />
                    </Tooltip>
                    :
                    <div className={classes.buttons}>
                        <Tooltip placement="bottom" title={'Evaluar CT'}>
                            <IconButton className={classes.editIcon} onClick={() => showTabEdit(id, row)}>
                                <Icon type="form" />
                            </IconButton>
                        </Tooltip>
                    </div>
            )
        }
    ];

    const showTabEdit = (id, row) => {
        props.setVisible(true)
        props.setIdCommunication(row.idCommunication);
        props.setRowData(row)
    }



    let isLoading = useSelector(getIsLoadingWorkCycleEvaluation);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(communications)) {
            fetchCommunications()
            fetchWorkCycleFilters()
        }
        if (isEmpty(communicationDispatchFilter)) fetchCommunicationDispatchFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchCommunicationsDispatch((props.userData.IdCompany === null ? props.userData.UserId : props.userData.IdCompany),
            {
                CommunicationProgramId: (props.formData.CommunicationProgramId === undefined) ? [] : props.formData.CommunicationProgramId,
                ColaboradorId: (props.formData.ColaboradorId === undefined) ? [] : props.formData.ColaboradorId,
                FrontId: (props.formData.FrontId === undefined) ? [] : props.formData.FrontId,
                SubdirectionId: (props.formData.Subdirection === undefined) ? [] : props.formData.Subdirection,
                ContractId: (props.formData.ContractId === undefined) ? [] : props.formData.ContractId,
                WorkId: (props.formData.WorkId === undefined) ? [] : props.formData.WorkId,
                TestId: (props.formData.TestId === undefined) ? [] : props.formData.TestId,
                ExternalEmployee: (props.formData.ExternalEmployee === undefined) ? '' : props.formData.ExternalEmployee,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && communications.length > 0) {
            pagination.total = communications[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchCommunications = () => dispatch(fetchCommunicationsDispatch((props.userData.IdCompany === null ? props.userData.UserId : props.userData.IdCompany), {
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchCommunicationDispatchFilterAction = () => dispatch(fetchCommunicationDispatchFilter((props.userData.IdCompany === null ? props.userData.UserId : props.userData.IdCompany)))

    const fetchWorkCycleFilters = () => dispatch(fetchWorkCycleFiltersFields((props.userData.IdCompany === null ? props.userData.UserId : props.userData.IdCompany), {
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            props.setSelectedRows(selectedRows)

            if (selectedRows.length > 1) {
                var employeeId = selectedRows[0].employeeId;
                var testId = selectedRows[0].idTest;
                var total = selectedRows.filter(x => x.employeeId === employeeId && x.idTest === testId).length;
                if (total === selectedRows.length) {
                    props.setDisableCTMultiple(false);
                }
                else {
                    props.setDisableCTMultiple(true);
                }

            }
            else {
                props.setDisableCTMultiple(true);
            }
        },

    };

    const visibleCheckbox = () => {
        var found = 's'
        if (!!communications) {
            if (communications.length > 1) {
                found = communications.find(x => x.employeeId !== communications[0].employeeId || x.idCourse !== communications[0].idCourse)
            }
        }
        return found === undefined ? true : false
    }

    return (props.children({ pagination: pagination, cols: columns, communications, communicationDispatchFilter, isLoading, handleTableChange: handleTableChange, rowSelection, visibleCheckbox: visibleCheckbox() }));
}


